/**
 * English language file.
 */
import * as actions from './actions.json';
import * as app from './app.json';
import * as error from './error.json';
import * as invoice from './invoice.json';
import * as user from './user.json';
import * as tag from './tag.json';
import * as constant from './constant.json';
import * as rule from './rule.json';
import * as directory from './directory.json';
import * as report from './report.json';
import * as reconciliation from './reconciliation.json';
import * as upload from './upload.json';
import * as notification from './notification.json';
import * as vat from './vat.json';
import * as viewer from './viewer.json';
import * as dialog from './dialog.json';
import * as releaseInvoice from './release-invoice.json';
import * as messages from './messages.json';

export default {
  actions,
  app,
  error,
  releaseInvoice,
  invoice,
  user,
  tag,
  constant,
  rule,
  directory,
  report,
  reconciliation,
  upload,
  notification,
  vat,
  viewer,
  dialog,
  ...messages,
};



// WEBPACK FOOTER //
// ./src/locale/en/index.js